<template>
  <div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <p v-if="bodyHtml" class="text-body whitespace-pre-wrap" v-html="bodyHtml"></p>
    <p v-else class="text-body whitespace-pre-wrap">{{ body }}</p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'MessageBubbleBody',
  props: {
    body: {
      type: String,
      default: '',
    },
    bodyHtml: {
      type: String,
      default: '',
    },
  },
};
</script>
